import React, { useEffect, useState } from 'react';

import { useLocation  } from 'react-router-dom';

import NavBarHeytelItems from './NavBarHeytelItems';
import ProcessHeytelInfo from './ProcessHeytelInfo';

const NavBarHeytelContainer = (props) => {
    const [componentName, setComponentName] = useState("");

    const { search } = useLocation();

    useEffect(() => {
        const compName = new URLSearchParams(search).get("Page");
        setComponentName(compName);
    }, []);

    useEffect(() => {
        if(props.pageEvent === "Header") {
            window.location.reload();
        }
    }, [props]);

    const renderComponent = (compName) => {
        let componentToRender;

        switch (compName) {
            case "ProcessInfo":
                componentToRender = <ProcessHeytelInfo />;
                break;
            
            default:
                componentToRender = <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
                break;
        }

        return componentToRender;
    }

    const changeComponent = (name) => {
        setComponentName(name);
    }

    return (
        <>
            <NavBarHeytelItems componentName={componentName} changeComponent={changeComponent}/>
            <div className="container my-3 my-lg-5">
                {renderComponent(componentName)}
            </div>
        </>
    )
}

export default NavBarHeytelContainer